import { SHOW_HOTKEYS_MODAL, HIDE_HOTKEYS_MODAL } from './types'

export const doShowHotkeysModal = () => ({
  type: SHOW_HOTKEYS_MODAL,
})

export const doHideHotkeysModal = () => ({
  type: HIDE_HOTKEYS_MODAL,
})
